import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {changeAnimationStart} from '../../../../general/actionCreators';

import Base, {getBounds as baseGetBounds} from './Base';

const Label = gettext('Start time');

const getBounds = (node, {animationStop}) => {
    const {offset, width, leftBound} = baseGetBounds(node);
    const step = width / 24;

    return {
        offset,
        width,
        leftBound,
        rightBound: step * animationStop,
    };
};

const Start = props => (
    <Base
        {...props}
        id="start"
        title={Label}
        getBounds={getBounds}
    />
);

const mapStateToProps = ({animationStart: index, animationStop}) => ({
    animationStop,
    index,
});

const mapDispatchToProps = dispatch => ({
    onMove: (event, index) => dispatch(changeAnimationStart(index)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Start);
